const ToolbarRow = ({ children, style }) => {
  return (
    <div
      className="d-flex border border-bottom-0 tiptap-toolbar flex-wrap align-items-center"
      style={{ padding: "4px", gap: "3px", ...style }}
    >
      {children}
    </div>
  );
};

export default ToolbarRow;
